module.exports = __webpack_public_path__ + "static/media/vn.6b3aef51.svg";